import Field from "@/components/admin/Field";

const SUB_FIELDS = [
  { key: "name", label: "Partner name", type: "text" },
  { key: "link", label: "Their website", type: "text" },
  { key: "logo", label: "Their mark — upload a file or search the web below", type: "logo" },
  { key: "eyebrow", label: "Label above the name (EN / AR)", type: "loc" },
  { key: "role", label: "Their role in one line (EN / AR)", type: "loc" },
  { key: "tagline", label: "Headline sentence (EN / AR)", type: "locarea" },
  { key: "statement", label: "Full statement — blank line between paragraphs (EN / AR)", type: "locarea" },
  { key: "figures", label: "Key figures", type: "statlist" },
  { key: "approvals", label: "Approvals & certifications", type: "strlist", placeholder: "ADNOC Approved Manufacturer" },
  {
    key: "sector_ids",
    label: 'Sectors to tag, comma separated (e.g. industry-manufacturing,technology-defense)',
    type: "text",
  },
];

const PLACEMENTS = [
  { key: "show_hero", label: "Homepage hero slide" },
  { key: "show_home", label: "Homepage feature section" },
  { key: "show_ventures", label: "Top of the Joint Ventures page" },
  { key: "show_page", label: "Dedicated partner page and menu link" },
  { key: "show_footer", label: "Footer line on every page" },
  { key: "show_sector_chips", label: "Tag on the Sectors page" },
];

/** Edits the whole strategic-partner block, including where it appears. */
export default function SpotlightField({ value, onChange }) {
  const v = value || {};
  const set = (key) => (val) => onChange({ ...v, [key]: val });

  return (
    <div className="space-y-5 md:col-span-2" data-testid="spotlight-field">
      <Field
        field={{ key: "enabled", label: "Show this partner across the website", type: "switch" }}
        value={v.enabled !== false}
        onChange={set("enabled")}
      />

      <div className="grid gap-5 md:grid-cols-2">
        {SUB_FIELDS.map((f) => (
          <Field key={f.key} field={f} value={v[f.key]} record={v} onChange={set(f.key)} />
        ))}
      </div>

      <div className="border border-border p-5" style={{ borderRadius: "var(--radius)" }}>
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-primary">Where should they appear?</p>
        <p className="mt-2 text-xs text-muted-foreground">
          All on by default. Switch any of these off to remove the partner from that place only.
        </p>
        <div className="mt-4 grid gap-3 md:grid-cols-2">
          {PLACEMENTS.map((p) => (
            <Field
              key={p.key}
              field={{ key: p.key, label: p.label, type: "switch" }}
              value={v[p.key] !== false}
              onChange={set(p.key)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
